export default {
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.template.title': 'Template',
  'pages.template.submit.success': 'Form submitted successfully!',
  'pages.template.form.name': 'Name',
  'pages.template.form.email': 'Email',
  'pages.template.form.department': 'Department',
  'pages.template.form.joinDate': 'Join Date',
  'pages.template.form.remarks': 'Remarks',
  'pages.template.placeholder.name': 'Please enter name',
  'pages.template.placeholder.email': 'Please enter email',
  'pages.template.placeholder.department': 'Please select a department',
  'pages.template.placeholder.remarks': 'Please enter remarks',
  'pages.template.validation.nameRequired': 'Please enter name',
  'pages.template.validation.emailRequired': 'Please enter email',
  'pages.template.validation.emailInvalid': 'Invalid email format',
  'pages.template.validation.departmentRequired': 'Please select a department',
  'pages.template.validation.joinDateRequired': 'Please select a join date',
  'pages.template.department.tech': 'Technology',
  'pages.template.department.sales': 'Sales',
  'pages.template.department.hr': 'Human Resources',
  'pages.template.department.finance': 'Finance',
  'pages.template.action.submit': 'Submit',
  'pages.template.action.reset': 'Reset',

  // Project Management
  'pages.projects.column.name': 'Name',
  'pages.projects.column.description': 'Description',
  'pages.projects.column.appCount': 'Apps',
  'pages.projects.column.memberCount': 'Members',
  'pages.projects.column.createdAt': 'Created At',
  'pages.projects.column.action': 'Action',
  'pages.projects.action.detail': 'Detail',
  'pages.projects.action.cancel': 'Cancel',
  'pages.projects.action.save': 'Save',
  'pages.projects.action.delete': 'Delete',
  'pages.projects.action.remove': 'Remove',
  'pages.projects.form.name': 'Project Name',
  'pages.projects.form.name.placeholder': 'Please enter project name',
  'pages.projects.form.description': 'Description',
  'pages.projects.form.description.placeholder':
    'Describe the microservices and team responsibilities in this project space...',
  'pages.projects.create.title': 'Create Project Space',
  'pages.projects.create.success': 'Project created successfully',
  'pages.projects.delete.confirm':
    'Are you sure you want to delete this project? All associated apps and resources will be destroyed!',
  'pages.projects.delete.success': 'Project deleted successfully',

  // Stats Banner
  'pages.projects.stats.totalProjects': 'Total Projects',
  'pages.projects.stats.runningApps': 'Running Apps',
  'pages.projects.stats.databases': 'DBs & Middleware',
  'pages.projects.stats.storage': 'Object Storage',
  'pages.projects.stats.cpuAllocation': 'CPU Quota Allocated',
  'pages.projects.stats.memoryAllocation': 'Memory Quota Allocated',
  'pages.projects.stats.healthRate': 'Health Rate',
  'pages.projects.view.card': 'Card View',
  'pages.projects.view.table': 'Table View',

  // Filter & Sort
  'pages.projects.filter.all': 'All Projects',
  'pages.projects.filter.running': 'Healthy',
  'pages.projects.filter.production': 'Production',
  'pages.projects.filter.agent': 'AI Agents',
  'pages.projects.filter.warning': 'Warning / Errors',
  'pages.projects.filter.managed': 'Managed by Me',
  'pages.projects.sort.recent': 'Recently Active',
  'pages.projects.sort.created': 'Creation Date',
  'pages.projects.sort.apps': 'App Count',
  'pages.projects.sort.quota': 'Resource Usage',
  'pages.projects.sort.name': 'Name (A-Z)',

  // Card
  'pages.projects.card.enter': 'Enter Workspace',
  'pages.projects.card.running': 'Running',
  'pages.projects.card.quota': 'Resource Utilization',
  'pages.projects.card.quickAction': 'Quick Action',
  'pages.projects.card.createApp': 'New App',
  'pages.projects.card.pin': 'Pin Project',
  'pages.projects.card.unpin': 'Unpin Project',

  'pages.projects.tab.overview': 'Overview',
  'pages.projects.tab.market': 'Marketplace',
  'pages.projects.tab.apps': 'Apps',
  'pages.projects.tab.databases': 'Databases',
  'pages.projects.tab.storage': 'Storage',
  'pages.projects.tab.members': 'Members',
  'pages.projects.tab.auditLog': 'Audit Log',
  'pages.projects.tab.settings': 'Settings',

  // Overview
  'pages.projects.overview.healthDistribution': 'App Health Distribution',
  'pages.projects.overview.resourceQuota': 'Resource Quota Usage',
  'pages.projects.overview.resourceUsage': 'Resource Usage Board',
  'pages.projects.overview.field.runningApps': 'Running Apps',
  'pages.projects.overview.cpuUsed': 'CPU Quota',
  'pages.projects.overview.memoryUsed': 'Memory Quota',
  'pages.projects.overview.storageUsed': 'Storage Space',
  'pages.projects.overview.quickEntry': 'Quick Actions',
  'pages.projects.overview.quickEntry.appList': 'App List',
  'pages.projects.overview.quickEntry.market': 'Install from Marketplace',
  'pages.projects.overview.quickEntry.inviteMember': 'Invite Member',
  'pages.projects.overview.serviceHealthRate': 'Service Health Rate',
  'pages.projects.overview.cpuQuota': 'CPU Quota',
  'pages.projects.overview.recentActivity': 'Recent Activities',
  'pages.projects.overview.noActivity': 'No recent activities recorded',

  // Marketplace
  'pages.projects.market.title': 'App & Middleware Marketplace',
  'pages.projects.market.subtitle':
    'Out-of-the-box first-party suites and standard middleware',
  'pages.projects.market.category.all': 'All Templates',
  'pages.projects.market.category.workvista': 'WorkVista Suite',
  'pages.projects.market.category.middleware': 'Data & Middleware',
  'pages.projects.market.installAction': 'Install to Project',
  'pages.projects.market.installModalTitle': 'Install App Template: {name}',
  'pages.projects.market.installSuccess':
    'Template deployed to project successfully',

  // Databases
  'pages.projects.databases.title': 'Database & Storage Instances',
  'pages.projects.databases.create': 'New Database Instance',
  'pages.projects.databases.column.name': 'Instance Name',
  'pages.projects.databases.column.engine': 'Engine & Version',
  'pages.projects.databases.column.status': 'Status',
  'pages.projects.databases.column.host': 'Connection Endpoint',
  'pages.projects.databases.column.storage': 'Storage Usage',
  'pages.projects.databases.connString': 'Connection String',
  'pages.projects.databases.action.restart': 'Restart Instance',
  'pages.projects.databases.action.stop': 'Stop Instance',
  'pages.projects.databases.createSuccess':
    'Database instance created successfully',
  'pages.projects.databases.actionSuccess':
    'Database action issued successfully',

  // Storage
  'pages.projects.storage.title': 'Object Storage (S3 Compatible)',
  'pages.projects.storage.create': 'New Bucket',
  'pages.projects.storage.column.bucket': 'Bucket Name',
  'pages.projects.storage.column.endpoint': 'S3 Endpoint',
  'pages.projects.storage.column.quota': 'Used / Quota',
  'pages.projects.storage.column.files': 'Objects',
  'pages.projects.storage.column.acl': 'Access Control',
  'pages.projects.storage.column.keys': 'Credentials (AK/SK)',
  'pages.projects.storage.createSuccess': 'Bucket created successfully',
  'pages.projects.storage.fileList': 'File Explorer',

  // Apps
  'pages.projects.app.column.status': 'Status',
  'pages.projects.app.column.category': 'Category',
  'pages.projects.app.column.repoUrl': 'Repository',
  'pages.projects.app.column.version': 'Version',
  'pages.projects.app.column.endpoints': 'Endpoints',
  'pages.projects.app.create.title': 'Create App',
  'pages.projects.app.create.success': 'App created successfully',
  'pages.projects.app.form.name.placeholder': 'Please enter app name',
  'pages.projects.app.form.category': 'App Category',
  'pages.projects.app.form.repoMode': 'Repository Source',
  'pages.projects.app.form.repoMode.create': 'Auto-create repository',
  'pages.projects.app.form.repoMode.bind': 'Bind existing repository',
  'pages.projects.app.form.repoMode.create.hint':
    'A repository will be created automatically following the Coral App standard, no address needed',
  'pages.projects.app.form.repoUrl': 'Repository URL',
  'pages.projects.app.form.repoUrl.invalid':
    'Please enter a valid Git repository URL',
  'pages.projects.app.overview': 'App Overview',
  'pages.projects.appStatus.draft': 'Draft',
  'pages.projects.appStatus.deploying': 'Deploying',
  'pages.projects.appStatus.running': 'Running',
  'pages.projects.appStatus.stopped': 'Stopped',
  'pages.projects.appStatus.failed': 'Failed',

  // App Detail Tab
  'pages.projects.app.tab.overview': 'Overview & Topology',
  'pages.projects.app.tab.logs': 'Live Container Logs',
  'pages.projects.app.tab.deploy': 'Deployment Config',
  'pages.projects.app.tab.history': 'Releases & Rollbacks',
  'pages.projects.app.pod.title': 'Pod Health & Resource Usage',
  'pages.projects.app.pod.name': 'Pod Name',
  'pages.projects.app.pod.node': 'Node',
  'pages.projects.app.pod.ip': 'Pod IP',
  'pages.projects.app.pod.restarts': 'Restarts',
  'pages.projects.app.pod.cpu': 'CPU Usage',
  'pages.projects.app.pod.memory': 'Memory Usage',
  'pages.projects.app.logs.autoScroll': 'Auto Scroll',
  'pages.projects.app.logs.clear': 'Clear',
  'pages.projects.app.logs.download': 'Download Logs',
  'pages.projects.app.logs.search': 'Search logs keyword...',
  'pages.projects.app.history.version': 'Version',
  'pages.projects.app.history.commit': 'Git Commit',
  'pages.projects.app.history.operator': 'Deployed By',
  'pages.projects.app.history.time': 'Deployed At',
  'pages.projects.app.history.rollback': 'Rollback to this version',
  'pages.projects.app.history.rollbackConfirm':
    'Are you sure you want to roll back to version {version}?',
  'pages.projects.app.history.rollbackSuccess': 'Rollback triggered',

  'pages.projects.app.column.branch': 'Branch',
  'pages.projects.app.column.image': 'Container Image',
  'pages.projects.app.column.imagePrefix': 'Image: {image}',
  'pages.projects.app.column.repoOrImage': 'Source / Image',
  'pages.projects.app.form.description': 'Description',
  'pages.projects.app.list.category.all': 'All',
  'pages.projects.app.list.healthRate': 'Service Health Rate',
  'pages.projects.app.repoMode.image': 'Container Image Deploy',
  'pages.projects.appCategory.agent': 'AI Agent',
  'pages.projects.appCategory.backend': 'Backend Service',
  'pages.projects.appCategory.frontend': 'Web Frontend',
  'pages.projects.appCategory.fullstack': 'Fullstack App',

  'pages.projects.app.wizard.title.template': 'New App / Dev Environment',
  'pages.projects.app.wizard.title.config': 'Configure & Launch App',
  'pages.projects.app.wizard.step1':
    'Step 1: Choose a ready-to-use dev template or a custom image',
  'pages.projects.app.wizard.step2':
    'Step 2: Configure app parameters and source mode',
  'pages.projects.app.wizard.createSuccess':
    'App "{name}" created successfully! Cloud instance is starting up',
  'pages.projects.app.wizard.customImage':
    'Start from a blank app / custom container image',
  'pages.projects.app.wizard.emptyCategory': 'No matching dev templates',
  'pages.projects.app.wizard.loadFailed':
    'Failed to load templates, please retry',
  'pages.projects.app.wizard.retry': 'Retry',
  'pages.projects.app.wizard.search.placeholder':
    'Search dev templates, languages, frameworks or stacks...',
  'pages.projects.app.wizard.category.all': 'All Templates',
  'pages.projects.app.wizard.category.official': 'Official Scaffolds',
  'pages.projects.app.wizard.category.featured': 'Featured',
  'pages.projects.app.wizard.category.frontend': 'Frontend / Fullstack',
  'pages.projects.app.wizard.category.backend': 'Backend / Microservices',
  'pages.projects.app.wizard.category.language': 'Runtimes',
  'pages.projects.app.wizard.category.framework': 'Frameworks',
  'pages.projects.app.wizard.category.ai': 'AI & Data',
  'pages.projects.app.wizard.hero.tip':
    'Choose an out-of-the-box scaffold to initialize Git & CI/CD, or deploy directly using a custom container image.',
  'pages.projects.app.wizard.featuredSection': 'Official Featured Scaffolds',
  'pages.projects.app.wizard.allSection': 'Template Library',
  'pages.projects.app.wizard.customImageCard.title':
    'Custom Container Image Deployment',
  'pages.projects.app.wizard.customImageCard.desc':
    'Pull existing images directly from Harbor, Docker Hub or private registries with no repository scaffolding needed.',
  'pages.projects.app.wizard.customImageCard.badge': 'Image Only / No Git',
  'pages.projects.app.wizard.customImageCard.action': 'Configure Image',
  'pages.projects.app.wizard.card.author': 'By: {author}',
  'pages.projects.app.wizard.card.use': 'Use Template',
  'pages.projects.app.wizard.card.details': 'Architecture Details',
  'pages.projects.app.wizard.card.featuredBadge': 'Featured',
  'pages.projects.app.wizard.card.officialBadge': 'Official',
  'pages.projects.app.wizard.card.specs': 'Default Specs',
  'pages.projects.app.wizard.card.port': 'Port',
  'pages.projects.app.wizard.filter.allTags': 'All Stacks',
  'pages.projects.app.wizard.filter.reset': 'Reset Filters',
  'pages.projects.app.wizard.drawer.title':
    'Template Architecture & Configuration Details',
  'pages.projects.app.wizard.drawer.scaffoldFeatures':
    'Out-of-the-box Features',
  'pages.projects.app.wizard.drawer.versions': 'Version & Image Matrix',
  'pages.projects.app.wizard.drawer.defaultResources':
    'Baseline Resource Specs',
  'pages.projects.app.wizard.drawer.gitScaffold':
    'Repository Initialization Strategy',
  'pages.projects.app.wizard.drawer.useThis': 'Use Template & Configure App',
  'pages.projects.app.wizard.empty.tip':
    'No matching dev templates found. Try modifying keywords or deploy directly using a custom container image.',

  'pages.projects.app.wizard.sourceMode.createGit.title':
    'Auto-create hosted Git repo',
  'pages.projects.app.wizard.sourceMode.createGit.badge':
    'Recommended / Auto-init',
  'pages.projects.app.wizard.sourceMode.createGit.desc':
    'Automatically initializes a repo in the built-in Git service, seeds it with the chosen template scaffold, and wires up a CI/CD pipeline.',
  'pages.projects.app.wizard.sourceMode.bindGit.title':
    'Bind an existing Git repo',
  'pages.projects.app.wizard.sourceMode.bindGit.badge': 'External repo',
  'pages.projects.app.wizard.sourceMode.bindGit.desc':
    'Link an existing GitHub / GitLab / Gitee repo and branch; every push triggers a build and rolling release.',
  'pages.projects.app.wizard.sourceMode.image.title':
    'Deploy directly from a container image (no Git)',
  'pages.projects.app.wizard.sourceMode.image.badge':
    'Image only / no Git dependency',
  'pages.projects.app.wizard.sourceMode.image.desc':
    'Start the instance directly from a Docker image (official or from a private registry), with no repo to create or bind.',

  'pages.projects.app.wizard.config.customImageApp':
    'Custom container image app',
  'pages.projects.app.wizard.config.customImageDesc':
    'Run any Docker image directly, with storage and networking attached',
  'pages.projects.app.wizard.config.changeTemplate': 'Change template',
  'pages.projects.app.wizard.config.basicInfo': 'Basic Info',
  'pages.projects.app.wizard.config.name.required': 'Please enter an app name',
  'pages.projects.app.wizard.config.name.pattern':
    'Only lowercase letters, digits and hyphens are allowed',
  'pages.projects.app.wizard.config.name.maxLength':
    'Must not exceed 50 characters',
  'pages.projects.app.wizard.config.name.extra':
    'Used as the service name and DNS prefix; cannot be changed after creation',
  'pages.projects.app.wizard.config.name.placeholder': 'e.g. my-node-service',
  'pages.projects.app.wizard.config.description.placeholder':
    'Briefly describe what this app is for',
  'pages.projects.app.wizard.config.category.required':
    'Please select an app category',
  'pages.projects.app.wizard.config.sourceStrategy': 'Source & Build Strategy',
  'pages.projects.app.wizard.config.sourceStrategy.hint':
    'Supports auto-created repos, binding an existing Git repo, or running a container image directly',
  'pages.projects.app.wizard.config.repoName': 'Hosted repo name',
  'pages.projects.app.wizard.config.repoName.extra':
    'The built-in Git service will auto-initialize this repo and push the template scaffold and CI/CD pipeline',
  'pages.projects.app.wizard.config.repoUrl.required':
    'Please enter the existing Git repo URL',
  'pages.projects.app.wizard.config.branch': 'Deploy branch',
  'pages.projects.app.wizard.config.image': 'Container image (Image:Tag)',
  'pages.projects.app.wizard.config.image.required':
    'Please enter a container image',
  'pages.projects.app.wizard.config.image.extra':
    'Pulls and runs an existing container image directly, no Git repo needed',
  'pages.projects.app.wizard.config.runtime': 'Runtime & Network Settings',
  'pages.projects.app.wizard.config.cpu': 'CPU Quota',
  'pages.projects.app.wizard.config.memory': 'Memory Quota',
  'pages.projects.app.wizard.config.port': 'Service Port',
  'pages.projects.app.wizard.config.port.required': 'Please enter the port',
  'pages.projects.app.wizard.config.publicDomain': 'Public Domain Routing',
  'pages.projects.app.wizard.config.on': 'On',
  'pages.projects.app.wizard.config.off': 'Off',
  'pages.projects.app.wizard.config.domainPreview': 'Public domain preview: ',
  'pages.projects.app.wizard.config.advanced':
    'Advanced options (env vars & startup args)',
  'pages.projects.app.wizard.config.customCommand':
    'Custom start command (Command & Args)',
  'pages.projects.app.wizard.config.customCommand.extra':
    "Leave blank to use the template image's default entrypoint",
  'pages.projects.app.wizard.config.storage': 'Persistent volume size (GB)',
  'pages.projects.app.wizard.config.storage.extra':
    "Mounted persistently to the app's /data directory",
  'pages.projects.app.wizard.config.backToTemplate': 'Back to templates',
  'pages.projects.app.wizard.config.submit': 'Create & Run Now',
  'pages.projects.app.wizard.config.descriptionFromTemplate':
    'Built from the {name} ({version}) dev template',

  // Members
  'pages.projects.member.column.name': 'Name',
  'pages.projects.member.column.email': 'Email',
  'pages.projects.member.column.role': 'Role',
  'pages.projects.member.column.joinedAt': 'Joined At',
  'pages.projects.member.add.title': 'Add Member',
  'pages.projects.member.add.success': 'Member added successfully',
  'pages.projects.member.form.selectCandidate':
    'Select from Organization / Tenant Members',
  'pages.projects.member.form.selectCandidate.placeholder':
    'Search by name, username or email',
  'pages.projects.member.form.member': 'Member Identifier / UUID',
  'pages.projects.member.form.member.required':
    'Please enter or select a member identifier / UUID',
  'pages.projects.member.form.member.placeholder':
    'Enter memberUuid or select above',
  'pages.projects.member.form.name': 'Member Name',
  'pages.projects.member.form.name.placeholder':
    'e.g. John Doe (Optional, synced from IAM automatically)',
  'pages.projects.member.form.email': 'Member Email',
  'pages.projects.member.form.email.placeholder':
    'e.g. john@company.com (Optional)',
  'pages.projects.member.form.role': 'Project Role',
  'pages.projects.member.role.admin': 'Project Admin',
  'pages.projects.member.role.member': 'Project Member',
  'pages.projects.member.remove.confirm':
    'Are you sure you want to remove this member?',
  'pages.projects.member.remove.success': 'Member removed',
  'pages.projects.member.permission': 'App Permissions',
  'pages.projects.permission.title': 'App Permissions for {name}',
  'pages.projects.permission.column.app': 'App',
  'pages.projects.permission.column.visible': 'Visible',
  'pages.projects.permission.column.deploy': 'Deploy',
  'pages.projects.permission.column.manage': 'Manage',
  'pages.projects.permission.save.success': 'Permissions saved',
  'pages.projects.permission.quickPreset': 'Quick Presets: ',
  'pages.projects.permission.presetViewer': 'All Read-Only',
  'pages.projects.permission.presetDeveloper': 'All Developer',
  'pages.projects.permission.presetAdmin': 'All Admin',

  // Audit Log
  'pages.projects.audit.noPermission':
    'Only project admins can view the audit log',
  'pages.projects.audit.column.operator': 'Operator',
  'pages.projects.audit.column.action': 'Action Type',
  'pages.projects.audit.column.target': 'Target',
  'pages.projects.audit.column.detail': 'Detail',
  'pages.projects.audit.column.createdAt': 'Time',
  'pages.projects.audit.action.projectCreate': 'Create Project',
  'pages.projects.audit.action.projectUpdate': 'Update Project',
  'pages.projects.audit.action.projectDelete': 'Delete Project',
  'pages.projects.audit.action.appCreate': 'Create App',
  'pages.projects.audit.action.appDeploy': 'Deploy App',
  'pages.projects.audit.action.appLifecycle': 'Lifecycle Change',
  'pages.projects.audit.action.appDelete': 'Delete App',
  'pages.projects.audit.action.memberAdd': 'Add Member',
  'pages.projects.audit.action.memberRemove': 'Remove Member',
  'pages.projects.audit.action.memberPermissionsUpdate':
    'Configure Permissions',
  'pages.projects.audit.action.databaseCreate': 'Create Database',
  'pages.projects.audit.action.databaseAction': 'Database Action',
  'pages.projects.audit.action.marketInstall': 'Install Market Template',

  // Deployment
  'pages.projects.deploy.title': 'Deployment Config',
  'pages.projects.deploy.noPermission':
    'Only project admins can configure deployment',
  'pages.projects.deploy.source': 'Source',
  'pages.projects.deploy.source.image': 'Image',
  'pages.projects.deploy.source.repoBuild': 'Build from repository',
  'pages.projects.deploy.branch': 'Branch',
  'pages.projects.deploy.image': 'Image',
  'pages.projects.deploy.resource': 'Resources',
  'pages.projects.deploy.cpu': 'CPU',
  'pages.projects.deploy.memory': 'Memory',
  'pages.projects.deploy.replicas': 'Replicas',
  'pages.projects.deploy.network': 'Network',
  'pages.projects.deploy.port': 'Container Port',
  'pages.projects.deploy.port.exposePublic': 'Public Access (Ingress)',
  'pages.projects.deploy.port.add': 'Add Port',
  'pages.projects.deploy.envVars': 'Environment Variables & Secrets',
  'pages.projects.deploy.envVars.add': 'Add Variable',
  'pages.projects.deploy.storage': 'Storage Volumes',
  'pages.projects.deploy.storage.add': 'Add Volume',
  'pages.projects.deploy.healthCheck': 'Health Check Probes',
  'pages.projects.deploy.healthCheck.enable': 'Enable Health Check',
  'pages.projects.deploy.healthCheck.path': 'Probe Path',
  'pages.projects.deploy.healthCheck.port': 'Probe Port',
  'pages.projects.deploy.submit': 'Save & Deploy Now',
  'pages.projects.deploy.success': 'Deployment submitted',

  // Lifecycle
  'pages.projects.lifecycle.start': 'Start',
  'pages.projects.lifecycle.stop': 'Stop',
  'pages.projects.lifecycle.stop.confirm':
    'Are you sure you want to stop this app?',
  'pages.projects.lifecycle.restart': 'Restart',
  'pages.projects.lifecycle.rollback': 'Rollback',
  'pages.projects.lifecycle.rollback.placeholder':
    'Select a version to roll back to',
  'pages.projects.lifecycle.delete': 'Delete',
  'pages.projects.lifecycle.delete.confirm':
    'Are you sure you want to delete this app? This cannot be undone',
  'pages.projects.lifecycle.success': 'Action submitted',

  // Project Settings & Quota
  'pages.projects.settings.basicInfo': 'Project Space Basic Info',
  'pages.projects.settings.saveChanges': 'Save Changes',
  'pages.projects.settings.saveSuccess':
    'Project basic information updated successfully',
  'pages.projects.settings.quotaSuccess':
    'Quota expansion request submitted (CPU: {cpu} Core, Memory: {memory} GiB) and applied',
  'pages.projects.settings.field.uuid': 'Project Space UUID / Namespace',
  'pages.projects.settings.quotaManagement': 'Compute & Resource Quota',
  'pages.projects.settings.applyQuota': 'Request Quota Expansion',
  'pages.projects.settings.quotaProtectionTitle':
    'Quota Protection Mechanism Active',
  'pages.projects.settings.quotaProtectionDesc':
    'When total CPU/memory of running microservices and AI Agents reaches the quota limit, new deployments will be safely intercepted to prevent node OOM.',
  'pages.projects.settings.cpuLimit': 'CPU Hard Limit (Core)',
  'pages.projects.settings.allocatedUsage': 'Allocated: {used} Core',
  'pages.projects.settings.memoryLimit': 'Memory Limit (GiB)',
  'pages.projects.settings.allocatedUsageGiB': 'Allocated: {used} GiB',
  'pages.projects.settings.storageLimit': 'Persistent Storage Limit (GiB)',
  'pages.projects.settings.mountedPvc': 'Mounted PVC: {used} GiB',
  'pages.projects.settings.dangerZone':
    'Project Lifecycle Management (Danger Zone)',
  'pages.projects.settings.archive.title': 'Archive this Project Space',
  'pages.projects.settings.archive.hint':
    'Freeze all running instances, halt compute billing, and securely retain data',
  'pages.projects.settings.archive.button': 'Archive Space',
  'pages.projects.settings.archive.confirm':
    'Are you sure you want to archive this project space?',
  'pages.projects.settings.archive.content':
    'After archiving, all microservices and agents will enter frozen state, computing billing stops, and configurations & PV data are retained.',
  'pages.projects.settings.archive.ok': 'Confirm Archive',
  'pages.projects.settings.archive.success':
    'Project space "{name}" archived successfully',
  'pages.projects.settings.destroy.title': 'Destroy this Project Space',
  'pages.projects.settings.destroy.hint':
    'Remove this project space and its associated app records. Irreversible. This project shares its Kubernetes namespace with other projects in the same tenant, so the namespace itself is not cleaned up.',
  'pages.projects.settings.destroy.button': 'Destroy Space',
  'pages.projects.settings.destroy.confirm':
    'High-risk operation: Confirm destruction of this project space?',
  'pages.projects.settings.destroy.content':
    'This operation is irreversible! All container Pods, PVC volumes, and team permissions in this namespace will be released.',
  'pages.projects.settings.destroy.ok': 'Force Destroy',
  'pages.projects.settings.destroy.success':
    'Project space "{name}" has been destroyed',
  'pages.projects.settings.expandModal.title': 'Request Quota Expansion',
  'pages.projects.settings.expandModal.ok': 'Confirm Expansion',
  'pages.projects.settings.expandModal.cpu': 'Target CPU Limit (Core)',
  'pages.projects.settings.expandModal.memory': 'Target Memory Limit (GiB)',
  'pages.projects.settings.expandModal.storage':
    'Target Persistent Storage Limit (GiB)',

  // Platform Management (placeholder)
  'pages.management.placeholder.fields': 'Planned fields / capabilities:',
  'pages.management.identities.description':
    'A unified identity directory for every working subject in the enterprise — human employees, external collaborators, agents, digital employees, and system accounts. Adding a project member will pull from here instead of each project maintaining its own member data.',
  'pages.management.identityType.human': 'Human Employee',
  'pages.management.identityType.external': 'External Collaborator',
  'pages.management.identityType.agent': 'Agent',
  'pages.management.identityType.digital': 'Digital Employee',
  'pages.management.identityType.system': 'System Account',
  'pages.management.roles.description':
    'A global role and permission matrix independent of any single project, defining access scope across app / data / API / agent dimensions per role — replacing the simple project-level admin/member split.',
  'pages.management.role.globalAdmin': 'Global Admin',
  'pages.management.role.workspaceOwner': 'Workspace Owner',
  'pages.management.role.developer': 'Developer',
  'pages.management.role.viewer': 'Viewer',
  'pages.management.role.agentCaller': 'Agent Caller',
  'pages.management.auditLog.description':
    'A platform-level, cross-project audit trail, filterable by project and visible only to roles with audit access. Whether to merge this with the per-project audit log is still to be decided.',
  'pages.management.auditLog.field.operator': 'Operator',
  'pages.management.auditLog.field.project': 'Project',
  'pages.management.auditLog.field.action': 'Action',
  'pages.management.auditLog.field.result': 'Result',
  'pages.management.auditLog.field.time': 'Time',
  'pages.management.clusters.description':
    'A Kubernetes cluster and infrastructure operations entry for global admins, covering nodes, resources, health checks, and alerts — mapping to the "Operations & Observability" capability.',
  'pages.management.clusters.field.nodes': 'Node Management',
  'pages.management.clusters.field.resource': 'Resource Monitoring',
  'pages.management.clusters.field.health': 'Health Checks',
  'pages.management.clusters.field.alerts': 'Alerts',
  'pages.auditLog.title': 'Security & AI Audit Dashboard',
  'pages.auditLog.description':
    'Centrally record platform lifecycle operations, sensitive data access, and AI Agent model invocations with token consumption for enterprise compliance and traceability.',
  'pages.auditLog.action.refresh': 'Refresh',
  'pages.auditLog.stats.totalOperations': 'Global Operations Today',
  'pages.auditLog.stats.sensitiveOperations':
    'Sensitive & High-risk Operations',
  'pages.auditLog.stats.aiCalls': 'AI Agent Invocations',
  'pages.auditLog.stats.totalTokens': 'Total Tokens Consumed Today',
  'pages.auditLog.stats.timesSuffix': 'ops',
  'pages.auditLog.stats.tenThousand': 'x10k',
  'pages.auditLog.filter.all': 'All Audits',
  'pages.auditLog.filter.operation': 'System Operation Audit',
  'pages.auditLog.filter.aiCall': 'AI Token Audit',
  'pages.auditLog.filter.dataAccess': 'Data Access Audit',
  'pages.auditLog.filter.keywordPlaceholder':
    'Search operator/Agent/action/target...',
  'pages.auditLog.filter.search': 'Search',
  'pages.auditLog.filter.startDate': 'Start Date',
  'pages.auditLog.filter.endDate': 'End Date',
  'pages.auditLog.table.operator': 'Operator',
  'pages.auditLog.table.type': 'Audit Type',
  'pages.auditLog.table.actionTarget': 'Action & Target',
  'pages.auditLog.table.project': 'Project',
  'pages.auditLog.table.metrics': 'AI / Performance Metrics',
  'pages.auditLog.table.status': 'Status',
  'pages.auditLog.table.time': 'Timestamp',
  'pages.auditLog.table.detail': 'Detail',
  'pages.auditLog.table.totalCount': 'Total {total} records',
  'pages.auditLog.badge.operation': 'System Operation',
  'pages.auditLog.badge.aiCall': 'AI Token Audit',
  'pages.auditLog.badge.dataAccess': 'Data Access',
  'pages.auditLog.status.success': 'Success',
  'pages.auditLog.status.warning': 'Warning',
  'pages.auditLog.status.failed': 'Failed',
  'pages.auditLog.operatorType.agent': 'Agent',
  'pages.auditLog.operatorType.system': 'System',
  'pages.auditLog.operatorType.human': 'User',
  'pages.auditLog.drawer.title': 'Audit Log Trace Details',
  'pages.auditLog.drawer.basicContext': 'Basic Context',
  'pages.auditLog.drawer.id': 'Audit ID:',
  'pages.auditLog.drawer.operator': 'Operator:',
  'pages.auditLog.drawer.project': 'Project:',
  'pages.auditLog.drawer.platformGlobal': 'Global Platform',
  'pages.auditLog.drawer.clientIp': 'Client IP:',
  'pages.auditLog.drawer.occurredAt': 'Timestamp:',
  'pages.auditLog.drawer.actionDetail': 'Action & Description',
  'pages.auditLog.drawer.action': 'Action Name:',
  'pages.auditLog.drawer.target': 'Target:',
  'pages.auditLog.drawer.detail': 'Execution Detail:',
  'pages.auditLog.drawer.aiDetail': 'AI Runtime Scheduling Details',
  'pages.auditLog.drawer.model': 'Base Model:',
  'pages.auditLog.drawer.promptTokens': 'Prompt Tokens:',
  'pages.auditLog.drawer.completionTokens': 'Completion Tokens:',
  'pages.auditLog.drawer.totalTokens': 'Total Tokens:',
  'pages.auditLog.drawer.latency': 'Latency:',
  'pages.auditLog.metric.prompt': 'Prompt',
  'pages.auditLog.metric.completion': 'Completion',
  'pages.auditLog.metric.latency': 'Latency',
  'pages.auditLog.metric.ip': 'IP',
  'pages.platformTenants.title': 'Tenant Management',
  'pages.platformUsers.title': 'User Management',
  'pages.platformUsers.resetPassword': 'Reset password',
  'pages.platformUsers.resetPasswordTitle': 'Reset password for "{name}"',
  'pages.platformUsers.resetPasswordNotice':
    'The old password stops working immediately. Share the new one with the user through a secure channel.',
  'pages.platformUsers.newPassword': 'New password',
  'pages.platformUsers.newPasswordRequired': 'Enter a new password',
  'pages.platformUsers.newPasswordLength': 'Password must be 6-64 characters',
  'pages.platformUsers.generatePassword': 'Generate',
  'pages.platformUsers.copyPassword': 'Copy password',
  'pages.platformUsers.passwordCopied': 'Copied to clipboard',
  'pages.platformUsers.passwordCopyFailed':
    'Copy failed, please copy it manually',
  'pages.platformUsers.resetPasswordSuccess': 'Password reset',
  'pages.platformUsers.avatar': 'Avatar',
  'pages.platformUsers.avatarUpload': 'Upload avatar',
  'pages.platformUsers.avatarHint': 'PNG, JPG or WEBP, up to 5 MB',
  'pages.platformUsers.uploadFailed': 'Upload failed, please try again',
  'pages.platformUsers.save': 'Save',
  'pages.platformUsers.reset': 'Reset',
  'pages.platformUsers.saveSuccess': 'Profile saved',
  'pages.platformUsers.website': 'Website',
  'pages.platformUsers.websiteInvalid': 'Enter a valid URL',
  'pages.platformUsers.country': 'Country',
  'pages.platformUsers.province': 'Province / State',
  'pages.platformUsers.city': 'City',
  'pages.platformUsers.postalCode': 'Postal code',
  'pages.platformUsers.identifierClearForbidden':
    'This user has no username, so phone and email cannot both be empty or they will be unable to sign in',
  'pages.platformUsers.usernameImmutableHint':
    'The username cannot be changed after creation',
  'pages.platformUsers.tab.basic': 'Basic Info',
  'pages.platformUsers.tab.tenants': 'Tenants',
  'pages.platformUsers.tab.identities': 'Linked Accounts',
  'pages.platformUsers.tab.loginHistory': 'Login History',
  'pages.platformUsers.userNotFound':
    'The user does not exist or has been deleted',
  'pages.platformUsers.sectionAccount': 'Account',
  'pages.platformUsers.sectionProfile': 'Profile',
  'pages.platformUsers.verified': 'Verified',
  'pages.platformUsers.unverified': 'Unverified',
  'pages.platformUsers.registerSourceLabel': 'Sign-up method',
  'pages.platformUsers.registerSource.adminCreated': 'Created by admin',
  'pages.platformUsers.registerSource.basic:phone': 'Phone',
  'pages.platformUsers.registerSource.basic:email': 'Email',
  'pages.platformUsers.registerSource.basic:username': 'Username',
  'pages.platformUsers.signedUp': 'Signed up',
  'pages.platformUsers.validity': 'Account validity',
  'pages.platformUsers.perpetual': 'Never expires',
  'pages.platformUsers.loginsCount': 'Sign-ins',
  'pages.platformUsers.lastLogin': 'Last sign-in',
  'pages.platformUsers.lastIp': 'Last sign-in IP',
  'pages.platformUsers.genderLabel': 'Gender',
  'pages.platformUsers.gender.M': 'Male',
  'pages.platformUsers.gender.F': 'Female',
  'pages.platformUsers.gender.U': 'Unknown',
  'pages.platformUsers.birthdate': 'Birthday',
  'pages.platformUsers.company': 'Company',
  'pages.platformUsers.address': 'Street address',
  'pages.platformUsers.tenantName': 'Tenant',
  'pages.platformUsers.tenantCode': 'Tenant code',
  'pages.platformUsers.departments': 'Departments',
  'pages.platformUsers.departmentPath': 'Department path',
  'pages.platformUsers.noDepartments': 'Not in any department',
  'pages.platformUsers.noIdentities': 'No linked accounts',
  'pages.platformUsers.idpName': 'Identity provider',
  'pages.platformUsers.idpCategory': 'Provider type',
  'pages.platformUsers.idpCategory.enterprise': 'Enterprise',
  'pages.platformUsers.idpCategory.social': 'Social',
  'pages.platformUsers.idpDisplayName': 'Account name',
  'pages.platformUsers.idpUserId': 'Provider user ID',
  'pages.platformUsers.bindTime': 'Linked at',
  'pages.platformUsers.noLoginHistory': 'No sign-in records',
  'pages.platformUsers.loginTime': 'Time',
  'pages.platformUsers.loginApp': 'Application',
  'pages.platformUsers.loginEvent': 'Event',
  'pages.platformUsers.loginResult': 'Result',
  'pages.platformUsers.loginIp': 'IP address',
  'pages.platformUsers.loginLocation': 'Location',
  'pages.platformUsers.loginClient': 'Browser / OS / Device',
  'pages.platformUsers.keywordLabel': 'Keyword',
  'pages.platformUsers.searchPlaceholder':
    'Search username, name, phone or email',
  'pages.platformUsers.user': 'User',
  'pages.platformUsers.userId': 'User ID',
  'pages.platformUsers.username': 'Username',
  'pages.platformUsers.name': 'Name',
  'pages.platformUsers.namePlaceholder': 'Full name',
  'pages.platformUsers.nickname': 'Nickname',
  'pages.platformUsers.phone': 'Phone',
  'pages.platformUsers.email': 'Email',
  'pages.platformUsers.password': 'Initial password',
  'pages.platformUsers.statusLabel': 'Status',
  'pages.platformUsers.status.Activated': 'Active',
  'pages.platformUsers.status.Suspended': 'Suspended',
  'pages.platformUsers.status.Deleted': 'Deleted',
  'pages.platformUsers.createdAt': 'Created At',
  'pages.platformUsers.updatedAt': 'Updated At',
  'pages.platformUsers.actions': 'Actions',
  'pages.platformUsers.edit': 'Edit',
  'pages.platformUsers.enable': 'Enable',
  'pages.platformUsers.disable': 'Suspend',
  'pages.platformUsers.delete': 'Delete',
  'pages.platformUsers.createUser': 'New User',
  'pages.platformUsers.detailTitle': 'User Details',
  'pages.platformUsers.tenants': 'Tenants',
  'pages.platformUsers.noTenants': 'Not a member of any tenant',
  'pages.platformUsers.usernamePlaceholder': 'Used for password sign-in',
  'pages.platformUsers.phonePlaceholder': 'Used for verification-code sign-in',
  'pages.platformUsers.emailPlaceholder': 'name@example.com',
  'pages.platformUsers.passwordHint':
    'Optional. The user can sign in with a verification code or reset the password later.',
  'pages.platformUsers.emailInvalid': 'Invalid email address',
  'pages.platformUsers.identifierRequired':
    'Fill in at least one of username, phone or email',
  'pages.platformUsers.createSuccess': 'User created',
  'pages.platformUsers.enableSuccess': 'Enabled',
  'pages.platformUsers.disableSuccess': 'Suspended',
  'pages.platformUsers.deleteSuccess': 'User deleted',
  'pages.platformUsers.enableConfirm': 'Enable this user?',
  'pages.platformUsers.disableConfirm':
    'The user will no longer be able to sign in to any tenant. Suspend?',
  'pages.platformUsers.batchEnable': 'Enable',
  'pages.platformUsers.batchDisable': 'Suspend',
  'pages.platformUsers.clearSelection': 'Clear selection',
  'pages.platformUsers.batchEnableConfirm': 'Enable {count} selected users?',
  'pages.platformUsers.batchDisableConfirm':
    '{count} selected users will no longer be able to sign in. Suspend?',
  'pages.platformUsers.deleteConfirmTitle': 'Delete user "{name}"?',
  'pages.platformUsers.deleteConfirmContent':
    'The account will be removed from the user pool and lose membership in every tenant. This cannot be undone.',
  'pages.platformTenants.searchPlaceholder': 'Search tenant name or UUID',
  'pages.platformTenants.keywordLabel': 'Keyword',
  'pages.platformTenants.name': 'Tenant Name',
  'pages.platformTenants.uuid': 'Tenant UUID',
  'pages.platformTenants.code': 'Tenant Code',
  'pages.platformTenants.memberCount': 'Member Count',
  'pages.platformTenants.createdAt': 'Created At',
  'pages.platformTenants.actions': 'Actions',
  'pages.platformTenants.viewDetail': 'View Details',
  'pages.platformTenants.backToList': 'Back to Tenant List',
  'pages.platformTenants.tabMembers': 'Members',
  'pages.platformTenants.tabDepartments': 'Organizations',
  'pages.platformTenants.keywordSearch':
    'Search name, phone, email, or job number',
  'pages.platformTenants.memberName': 'Name',
  'pages.platformTenants.memberPhone': 'Phone',
  'pages.platformTenants.memberEmail': 'Email',
  'pages.platformTenants.memberJobNumber': 'Job Number',
  'pages.platformTenants.memberPosition': 'Position',
  'pages.platformTenants.memberStatus': 'Status',
  'pages.platformTenants.statusEnabled': 'Active',
  'pages.platformTenants.statusDisabled': 'Disabled',
  'pages.platformTenants.memberRole': 'Role',
  'pages.platformTenants.admin': 'Admin',
  'pages.platformTenants.regularMember': 'Member',
  'pages.platformTenants.leader': 'Department Leader',
  'pages.platformTenants.drawerTitle': 'Member Profile Details',
  'pages.platformTenants.joinedAt': 'Joined At',
  'pages.platformTenants.username': 'Username',
  'pages.platformTenants.department': 'Department',
  'pages.platformTenants.includeChildren': 'Include Sub-departments',
  'pages.platformTenants.selectDepartmentPrompt':
    'Please select a department on the left to view members',
  'pages.platformTenants.noDepartments': 'No Department Data',
  'pages.platformTenants.totalCount': 'Total {total} items',
  'pages.platformTenants.tabApps': 'Apps',
  'pages.platformTenants.description': 'Description',
  'pages.platformTenants.logo': 'Logo',
  'pages.platformTenants.logoUpload': 'Upload logo',
  'pages.platformTenants.logoHint': 'PNG, JPG, SVG or WebP, up to 5 MB',
  'pages.platformTenants.nameRequired': 'Enter a tenant name',
  'pages.platformTenants.saveSuccess': 'Tenant updated',
  'pages.platformTenants.saveFailed': 'Save failed. Try again later.',
  'pages.platformTenants.uploadFailed': 'Logo upload failed',
  'pages.platformTenants.appName': 'App name',
  'pages.platformTenants.appId': 'App ID',
  'pages.platformTenants.installSource': 'Source',
  'pages.platformTenants.installSourcePackage': 'Plan',
  'pages.platformTenants.installSourceTenant': 'Individually granted',
  'pages.platformTenants.noApps': 'This tenant has no apps yet',
  'pages.platformTenants.appsLoadFailed': 'Failed to load apps',
  'pages.platformTenants.tabBasic': 'Basic info',
  'pages.platformTenants.save': 'Save',
  'pages.platformTenants.reset': 'Reset',
  'pages.platformTenants.updatedAt': 'Updated at',
  'pages.platformTenants.profileCard': 'Profile',
  'pages.platformTenants.infoCard': 'Tenant details',
  'pages.myTenants.title': 'Tenant Settings',
  'pages.myTenants.member': 'Member',
  'pages.myTenants.empty': 'You have not joined any organization yet',
  'pages.myTenants.selectTenant':
    'Could not determine the current tenant. Please sign in again.',
  'pages.platformTenants.loadCommercialConfigFailed':
    'Failed to load commercial settings',
  'pages.platformTenants.loadCommercialStatusFailed':
    "Failed to load the tenant's commercial status",
  'pages.platformTenants.grantSuccess': 'Grant applied',
  'pages.platformTenants.grantFailed': 'Grant failed',
  'pages.platformTenants.subscriptionType': 'Type',
  'pages.platformTenants.status': 'Status',
  'pages.platformTenants.target': 'Target',
  'pages.platformTenants.adminGift': 'Admin gift',
  'pages.platformTenants.startsAt': 'Starts at',
  'pages.platformTenants.expiresAt': 'Expires at',
  'pages.platformTenants.perpetual': 'No expiry',
  'pages.platformTenants.purchaseParams': 'Purchase details',
  'pages.platformTenants.orderNo': 'Order no.',
  'pages.platformTenants.orderDefaultPlan': 'System default',
  'pages.platformTenants.orderMarketFree': 'Free from App Market',
  'pages.platformTenants.appsCount': '{count} apps',
  'pages.platformTenants.featureCode': 'Entitlement code',
  'pages.platformTenants.featureName': 'Entitlement',
  'pages.platformTenants.featureType': 'Type',
  'pages.platformTenants.finalValue': 'Effective value',
  'pages.platformTenants.sources': 'Sources',
  'pages.platformTenants.tenantCommercialStatus': 'Commercial status',
  'pages.platformTenants.adminGrant': 'Admin grant',
  'pages.platformTenants.entitlementIntro':
    "These are the tenant's effective entitlements. Business systems should authorize by entitlement code, not by plan name.",
  'pages.platformTenants.subscriptions': 'Subscriptions',
  'pages.platformTenants.finalEntitlements': 'Effective entitlements',
  'pages.platformTenants.tabEntitlements': 'Entitlements',
  'pages.platformTenants.tabRoles': 'Roles',
  'pages.platformTenants.tabAudit': 'Audit log',
  'pages.platformTenants.detailTitle': 'Tenant details',
  'pages.platformTenants.typePlan': 'Plan subscription',
  'pages.platformTenants.typeAddon': 'Add-on',
  'pages.platformTenants.typeManualGrant': 'Manual grant',
  'pages.platformTenants.on': 'On',
  'pages.platformTenants.off': 'Off',
  'pages.platformTenants.seatsUnit': '{count} seats',
  'pages.platformTenants.quantityUnit': 'Qty {count}',
  'pages.platformTenants.monthsUnit': '{count} months',
  'pages.platformTenants.amountYuan': '¥{amount}',
  'pages.platformTenants.refresh': 'Refresh',
  'pages.platformTenants.grantType': 'Grant type',
  'pages.platformTenants.planVersion': 'Plan version',
  'pages.platformTenants.priceItem': 'Price',
  'pages.platformTenants.addonProduct': 'Add-on product',
  'pages.platformTenants.purchaseQuantity': 'Quantity',
  'pages.platformTenants.targetFeature': 'Entitlement',
  'pages.platformTenants.switchState': 'State',
  'pages.platformTenants.numericValue': 'Value',
  'pages.platformTenants.applicationCodes': 'App codes (one per line)',
  'pages.platformTenants.seatCount': 'Seats',
  'pages.platformTenants.months': 'Months',
  'pages.platformTenants.paidAmount': 'Amount paid (CNY)',
  'pages.myTenants.detailTitle': 'Tenant Settings',
};
